export const resolveMyRequestsPath = (prefix: string): string => {
  const mapperPaths: { [key: string]: string } = {
    ess: 'leave-request',
    mr: 'material-request',
  };
  return mapperPaths[prefix];
};
